import {getQueryStringArgs} from '../query-string';
import {
    showLoginBox
} from './postmessage'
const queryParams = getQueryStringArgs(location.search);
let {
    token: tokenInURL,
    fr
} = queryParams;
if (!fr && window.qiankunData && window.qiankunData.fr) {
    fr = window.qiankunData.fr
}
console.log('queryParams:', window.qiankunData)
const USERINFO_KEY = fr === 'mgr' ? 'XIAOHOUCODE_MGR_USERINFO' : 'XIAOHOUCODE_USERINFO';

const getUserinfo = function () {
    const userinfoJson = localStorage.getItem(USERINFO_KEY);
    const userinfo = userinfoJson ?
        JSON.parse(userinfoJson) :
        {};
    return userinfo;
};

const getUserToken = function () {
    if (typeof tokenInURL !== 'undefined') return tokenInURL;
    const userinfo = getUserinfo();
    const {accessToken: token} = userinfo;
    // if (!token && fr === 'community') {
    //     showLoginBox()
    // }
    return token;
};

const clearUserinfo = function () {
    localStorage.removeItem(USERINFO_KEY);
};

const getCityCode = function () {
    const cityCode = localStorage.getItem('CITY_CODE');
    const cityCodeInfo = cityCode ?
        cityCode :
        '';
    return cityCodeInfo;
};

export {
    fr,
    getUserinfo,
    getUserToken,
    getCityCode,
    clearUserinfo,
    queryParams
};
